"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors = {
    black: '#000000',
    lightViolet: '#5f5b69',
    violet: '#35323E',
    darkViolet: '#0f0a18',
    blue: '#388180',
    bubblegum: '#f5a3b7',
    olive: '#8AB660',
    darkOlive: '#78A44C',
    burgundy: '#9F1D22',
    darkBurgundy: '#7F151A',
    lightOrange: '#ffa95c',
    orange: '#FF782D',
    darkOrange: '#FF6205',
    fuchsia: '#EE6D79',
    butter: '#FAF5B0',
    yellow: '#FBF004',
    darkYellow: '#7C7504',
    beige: '#FBF4CA',
    white: '#FFFFFF',
};
exports.default = colors;
//# sourceMappingURL=colors.js.map